module.exports = __webpack_public_path__ + "img/pp-slides.5612e28.png";